import React from 'react';

import { useNavigate } from 'react-router-dom';

import CliveChatMessage from '../Chat/CliveChatMessage';

import Button from '~/core/atoms/Buttons/Button';

interface CliveClaimSuccessMessageProps {
  claimNumber: string;
}

const CliveClaimSuccessMessage: React.FC<CliveClaimSuccessMessageProps> = ({ claimNumber }) => {
  const navigate = useNavigate();

  const handleClaimClick = () => {
    navigate(`/claims/${claimNumber}`);
  };

  const message = (
    <div className="flex flex-col items-start justify-start gap-12">
      <div>I successfully processed the information provided and created a new claim</div>
      <div className="flex w-full items-center justify-start gap-12">
        <span className="bg-bluesky-700/15 flex h-20 items-center rounded-xl px-12 text-sm">{claimNumber}</span>
        <Button onClick={handleClaimClick} variant="primary" size="xs" outline>
          Go to claim
        </Button>
      </div>
    </div>
  );

  return <CliveChatMessage message={message} />;
};

export default CliveClaimSuccessMessage;
